import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=7a1e5a90&scoped=true&"
var script = {}
import style0 from "./notFound.vue?vue&type=style&index=0&id=7a1e5a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1e5a90",
  null
  
)

export default component.exports